"use strict";

var _regeneratorRuntime = require("/codebuild/output/src400645628/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

var _lodash = _interopRequireDefault(require("lodash.isequal"));

var _moment = _interopRequireDefault(require("moment"));

var _CreditsRemaining = _interopRequireDefault(require("../../CreditsRemaining"));

require("../styles/_recurring-credits-modal.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var RecurringCreditsModal = /*#__PURE__*/function (_Component) {
  _inherits(RecurringCreditsModal, _Component);

  var _super = _createSuper(RecurringCreditsModal);

  function RecurringCreditsModal() {
    var _this;

    _classCallCheck(this, RecurringCreditsModal);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "setDefaultValues", function () {
      var _this$props = _this.props,
          selectedTeam = _this$props.selectedTeam,
          _this$props$orgRecurr = _this$props.orgRecurringBalance,
          orgRecurringBalance = _this$props$orgRecurr === void 0 ? 0 : _this$props$orgRecurr;

      if (!selectedTeam) {
        return;
      }

      var _ref = selectedTeam.creditRule || {},
          _ref$creditQuantity = _ref.creditQuantity,
          creditQuantity = _ref$creditQuantity === void 0 ? 0 : _ref$creditQuantity,
          _ref$startDate = _ref.startDate,
          startDate = _ref$startDate === void 0 ? null : _ref$startDate,
          _ref$endDate = _ref.endDate,
          endDate = _ref$endDate === void 0 ? null : _ref$endDate;

      _this.setState({
        creditQuantity: creditQuantity,
        startDate: startDate,
        endDate: endDate,
        orgRecurringBalance: orgRecurringBalance
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setDate", function (type) {
      return function (date) {
        _this.setState(_defineProperty({}, type, date));
      };
    });

    _defineProperty(_assertThisInitialized(_this), "handleCreditRuleQuantityChange", function (value) {
      var isUnlimited = _this.props.isUnlimited;
      var _this$state = _this.state,
          creditQuantity = _this$state.creditQuantity,
          orgRecurringBalance = _this$state.orgRecurringBalance;
      var creditsDiff = isUnlimited ? 0 : value - creditQuantity;

      if (orgRecurringBalance <= 0 && creditsDiff >= 1) {
        return;
      }

      _this.setState({
        orgRecurringBalance: orgRecurringBalance - creditsDiff,
        creditQuantity: value
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleSaveCreditRule", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _this$props2, createTeamCreditRule, updateCreditRule, onSave, selectedTeam, _this$state2, creditQuantity, startDate, endDate, teamId, creditRule, newCreditRuleInput, _yield$createTeamCred, _data, _error, teamWithCreditRule, _yield$updateCreditRu, data, error, teamWithUpdatedCreditRule;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props2 = _this.props, createTeamCreditRule = _this$props2.createTeamCreditRule, updateCreditRule = _this$props2.updateCreditRule, onSave = _this$props2.onSave, selectedTeam = _this$props2.selectedTeam;
              _this$state2 = _this.state, creditQuantity = _this$state2.creditQuantity, startDate = _this$state2.startDate, endDate = _this$state2.endDate;

              if (!(!selectedTeam || Number.isNaN(creditQuantity) || !startDate || !endDate)) {
                _context.next = 4;
                break;
              }

              return _context.abrupt("return");

            case 4:
              teamId = selectedTeam.teamId;
              creditRule = selectedTeam.creditRule || {};
              newCreditRuleInput = _objectSpread(_objectSpread({}, creditRule), {}, {
                teamId: teamId,
                startDate: startDate,
                endDate: endDate,
                creditQuantity: creditQuantity
              });

              if (creditRule.creditRuleId) {
                _context.next = 17;
                break;
              }

              _context.next = 10;
              return createTeamCreditRule(newCreditRuleInput);

            case 10:
              _yield$createTeamCred = _context.sent;
              _data = _yield$createTeamCred.data;
              _error = _yield$createTeamCred.error;

              if (!(!_data || _error)) {
                _context.next = 15;
                break;
              }

              return _context.abrupt("return");

            case 15:
              teamWithCreditRule = _objectSpread(_objectSpread({}, selectedTeam), {}, {
                creditRule: _objectSpread({}, _data.createCreditRule)
              });
              return _context.abrupt("return", void onSave({
                updatedTeam: teamWithCreditRule,
                shouldUpdateParentTeams: true
              }));

            case 17:
              _context.next = 19;
              return updateCreditRule({
                creditRuleId: creditRule.creditRuleId,
                input: {
                  creditQuantity: creditQuantity,
                  startDate: startDate,
                  endDate: endDate
                }
              });

            case 19:
              _yield$updateCreditRu = _context.sent;
              data = _yield$updateCreditRu.data;
              error = _yield$updateCreditRu.error;

              if (!(!data || error)) {
                _context.next = 24;
                break;
              }

              return _context.abrupt("return");

            case 24:
              teamWithUpdatedCreditRule = _objectSpread(_objectSpread({}, selectedTeam), {}, {
                creditRule: _objectSpread({}, data.updateCreditRule)
              });
              return _context.abrupt("return", void onSave({
                updatedTeam: teamWithUpdatedCreditRule,
                shouldUpdateParentTeams: true
              }));

            case 26:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _this.state = {
      creditQuantity: 0,
      startDate: null,
      endDate: null,
      orgRecurringBalance: 0
    };
    return _this;
  }

  _createClass(RecurringCreditsModal, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if ((0, _lodash.default)(prevProps, this.props)) {
        return;
      }

      this.setDefaultValues();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          isVisible = _this$props3.isVisible,
          selectedTeam = _this$props3.selectedTeam,
          onClose = _this$props3.onClose,
          isUnlimited = _this$props3.isUnlimited;
      var _this$state3 = this.state,
          orgRecurringBalance = _this$state3.orgRecurringBalance,
          startDate = _this$state3.startDate,
          endDate = _this$state3.endDate,
          creditQuantity = _this$state3.creditQuantity;

      if (!selectedTeam) {
        return null;
      }

      var name = selectedTeam.name;
      var startDateObject = typeof startDate === 'string' ? (0, _moment.default)(startDate, 'x') : startDate;
      var endDateObject = typeof endDate === 'string' ? (0, _moment.default)(endDate, 'x') : endDate;
      return /*#__PURE__*/_react.default.createElement(_uiKit.FormModal, {
        title: "Set Recurring Credits",
        subtitle: "Allocate credits to ".concat(name),
        visible: isVisible,
        onClose: onClose,
        onSave: this.handleSaveCreditRule,
        saveDisabled: !startDate || !endDate
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "recurring-credits-modal"
      }, /*#__PURE__*/_react.default.createElement(_CreditsRemaining.default, {
        balance: orgRecurringBalance,
        isRecurring: true,
        isUnlimited: isUnlimited
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "recurring-credits-modal__settings"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "recurring-credits-modal__settings__quantity"
      }, /*#__PURE__*/_react.default.createElement(_uiKit.Text, null, "How many video credits do you want to allocate?"), /*#__PURE__*/_react.default.createElement(_uiKit.NumberChanger, {
        value: creditQuantity,
        onChangeNumber: this.handleCreditRuleQuantityChange
      })), /*#__PURE__*/_react.default.createElement("hr", null), /*#__PURE__*/_react.default.createElement("div", {
        className: "recurring-credits-modal__settings__dates"
      }, /*#__PURE__*/_react.default.createElement(_uiKit.DatePicker, {
        onSelectStartDate: this.setDate('startDate'),
        onSelectEndDate: this.setDate('endDate'),
        startDate: startDateObject,
        endDate: endDateObject,
        startLabel: "Start Date",
        endLabel: "End Date",
        labelProps: {
          required: true
        }
      })))));
    }
  }]);

  return RecurringCreditsModal;
}(_react.Component);

exports.default = RecurringCreditsModal;